import axios from 'axios';
import constant from './constant';
const client = axios.create({
  baseURL: constant.API_URL,
});
// Request interceptor
client.interceptors.request.use(
  (config) => {
    // Modify the config object before sending the request
    return config;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('USER_TOKEN')
      window.location.href = '/login'; // or '/error_401' if you have a specific page for 401 errors
    }else if(error.response && error.response.status === 404){
      // window.location.href = '/error_404';
    }
    return Promise.reject(error);
  }
);

// Response interceptor
client.interceptors.response.use(
  (response) => {
    // Handle the response data
    // const currentUrl = window.location.href;
    // const containsQuestionMark = currentUrl.includes('?');
    // if(containsQuestionMark){
    //   window.location.href = '/error_404';
    // }
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('USER_TOKEN')
      window.location.href = '/login'; // or '/error_401' if you have a specific page for 401 errors
    }else if(error.response && error.response.status === 404){
      // window.location.href = '/error_404';
    }
    return Promise.reject(error);
  }
);
function getauthtoken(){
  let token = localStorage.getItem('USER_TOKEN');
  let Authtoken = '';
  if(token !=null && token !='' && token !=undefined){
      Authtoken = token;
  }
  const config = {
    headers: { 'X-Authorization': `Bearer ${Authtoken}`, 'X-Access-Key': 'zTREyZOOiwRvZg==' }
  };
  return config;
}
function getauthtemptoken(){
  let token = localStorage.getItem('TEMP_USER_TOKEN');
  let Authtoken = '';
  if(token !=null && token !='' && token !=undefined){
      Authtoken = token;
  }
  const config = {
    headers: { 'X-Authorization': `Bearer ${Authtoken}`, 'X-Access-Key': 'zTREyZOOiwRvZg==' }
  };
  return config;
}
export class ApiService {
  static async fetchData(url) {
    try {
      const response = await client.get(url, getauthtoken());
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  static async postData(url,data) {
    try {
      const response = await client.post(url, data, getauthtoken());
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  static async loginProccessPostData(url,data) {
    try {
      const response = await client.post(url, data, getauthtemptoken());
      return response.data;
    } catch (error) {
      // console.error('Error posting data:', error);
      throw error;
    }
  }
  static async filterPostData(url,data) {
    try {
      const response = await client.post(url, data, getauthtoken());
      return response.data;
    } catch (error) {
      //console.error('Error posting data:', error);
      throw error;
    }
  }
  static async numberFormat(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
}



